module.exports = __webpack_public_path__ + "img/logo_white.f4821daf.svg";